import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from 'src/app/http.service';
import { ClipboardService } from 'ngx-clipboard';
@Component({selector:'app-consolidated-phone-report',templateUrl:'./consolidated-phone-report.component.html',styleUrls:['./consolidated-phone-report.component.scss']})
export class ConsolidatedPhoneReportComponent implements OnInit {
 @Input() playerUuid = '';
 @Input() reportCompanyUuid = '';
 report:any=null; error=''; loading=false;
 @Input() playerLabel='';
 @Input() closeReport: (() => void) | null = null;
 @Input() playerReport=false; matchBy='phone'; matchValue=''; allTime=false;
 dateFrom=new Date(Date.now()+28800000).toISOString().slice(0,10);
 dateTo=this.dateFrom; detail:any=null; detailPlayer:any=null; detailOffset=0; detailError=''; detailLoading=false;
 private criteria:any=null;
 async searchPlayers(){
  this.loading=true;this.report=null;this.error='';this.detail=null;this.detailPlayer=null;
  this.criteria={report_kind:'player-winloss',report_company_uuid:this.reportCompanyUuid,consolidated_wallet_context:true,
   match_by:this.matchBy,match_value:this.matchValue,all_time:this.allTime,date_from:this.dateFrom,date_to:this.dateTo};
  try{const r:any=await this.http.post('/admin/consolidated-wallet/phone-report',this.criteria);
   if(!r?.status)throw Error(r?.message || 'Unable to load report.');this.report=r;
  }catch(e){this.error=e.message || 'Unable to load report.';}finally{this.loading=false;}
 }
 async showEntries(player:any,offset=0){
  this.detailPlayer=player;this.detailOffset=offset;this.detail=null;this.detailError='';this.detailLoading=true;
  try{const r:any=await this.http.post('/admin/consolidated-wallet/phone-report',{...this.criteria,detail_player_uuid:player.uuid,offset});
   if(!r?.status)throw Error(r?.message || 'Unable to load transactions.');this.detail=r;
  }catch(e){this.detailError=e.message || 'Unable to load transactions.';}finally{this.detailLoading=false;}
 }

 copied=false;
 manualFields = [
  {key:'gameId',label:'Game ID',value:''},
  {key:'game',label:'Game / Brand',value:''},
  {key:'type',label:'Type',value:''},
  {key:'totalBet',label:'Total Bet (RM)',value:''},
  {key:'bonus',label:'Bonus (RM)',value:'0'},
  {key:'withdrawal',label:'Request Withdraw (RM)',value:''},
  {key:'betRange',label:'Bet Range (RM)',value:''}
 ];
 date=new Date(Date.now()+28800000).toISOString().slice(0,10);
 constructor(private http:HttpService,private route:ActivatedRoute,private clipboard:ClipboardService){}
 ngOnInit(){this.reportCompanyUuid=this.reportCompanyUuid || this.route.snapshot.queryParams.report_company || this.http.getStaticSelectedCompany();this.playerReport=this.playerReport || this.route.snapshot.queryParams.report === 'player-winloss';if(!this.playerReport)this.load();else if(this.closeReport && this.matchValue)this.searchPlayers();}
 async load(){this.loading=true;this.error='';this.report=null;this.copied=false;
  try {const r:any=await this.http.post('/admin/consolidated-wallet/phone-report',{report_company_uuid:this.reportCompanyUuid,player_uuid:this.playerUuid || undefined,date:this.date,consolidated_wallet_context:true});
   if(!r?.status) throw Error(r?.message || 'Unable to load report.');this.report=r;
  }catch(e){this.error=e.message || 'Unable to load report.';}finally{this.loading=false;}
 }
 field(key:string){return this.manualFields.find(f=>f.key===key)?.value.trim() || '';}
 amount(value:any){
  if(value===null || value===undefined || value==='') return '';
  const n=Number(String(value).replace(/,/g,''));
  return Number.isFinite(n)?n.toLocaleString('en-US',{minimumFractionDigits:n===0?0:2,maximumFractionDigits:2}):String(value).trim();
 }
 get preview(){
  const r=this.report;
  if(!r) return '';
  if(!r.selected) return r.text;
  if(!r.details || !r.current_company) return '';
  const d=r.details, current=r.current_company, separator='━━━━━━━━━━━━━━';
  const date=r.date.split('-').reverse().join('/')+' '+d.time;
  return [
   '🏦 BANKS', ...d.banks.map(b=>b.title+' : RM'+this.amount(b.balance)),
   '',separator,'','📋 REPORT',
   'Date : '+date,'Code : '+r.selected.code,'Staff : '+d.staff,'Game ID : '+this.field('gameId'),
   '', 'Game : '+this.field('game'),'Type : '+this.field('type'),
   'Total Bet : RM'+this.amount(this.field('totalBet')),'Bonus : RM'+this.amount(this.field('bonus')),
   '',separator,'','👤 '+r.selected.name,
   'Topup : RM'+this.amount(current.totals.deposit),'Withdraw : RM'+this.amount(current.totals.withdraw),
   'No. Topup : '+d.no_of_topup,'No. Withdraw : '+d.no_of_withdraw,
   '', 'Profit : RM'+this.amount(current.totals.profit),'Total Profit : RM'+this.amount(current.total.profit),
   'consolidate Profit : RM'+this.amount(r.total?.profit),
   '', 'Last Deposit : RM'+this.amount(d.last_topup),'Last Withdraw : RM'+this.amount(d.last_withdrawal),
   'Request Withdraw : RM'+this.amount(this.field('withdrawal')),
   '', 'Bet Range : RM'+this.field('betRange')
  ].join('\n');
 }
 copy(){if(this.preview){this.copied=this.clipboard.copyFromContent(this.preview);}}
 width(amount:number){const max=this.report?.brands?.[0]?.withdraw || 0;return max>0?100*amount/max:0;}
}
